export default [

     {
          path: '/krisubmission',
          name: 'Krisubmission',
          component: () => import("@/views/Page/Krisubmission/Krisubmission.vue"),
           meta: {
               title: 'Krisubmission',
          },
     }
];